// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"950":"df6dd38e","3084":"a31e4181","5314":"df6dd38e","5442":"df6dd38e","8596":"f12459ff"}[chunkId] + ".chunk.css";
};